import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-30b72526"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "prepend"
}, "中国+86", -1));
import { toRefs, ref, reactive, unref, onMounted } from "vue";
import { ElMessage } from "element-plus";
import Cookies from 'js-cookie';
import { updateUserPassword, checkMobile, getVerificationCode, checkVerificationCode, updateUserMobile } from "./service";
export default {
  __name: 'index',
  props: {
    showLogin: {
      type: Boolean,
      default: true
    },
    userInfo: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String,
      default: ''
    },
    accountAction: {
      type: Boolean,
      default: false
    },
    isAccount: {
      type: Boolean,
      default: false
    }
  },
  emits: ['changeLoginType', 'onChangeAccount'],
  setup(__props, {
    emit: __emit
  }) {
    let props = __props;
    const emit = __emit;
    const changeLoginType = val => emit('changeLoginType', val);
    const changeAccount = (val, action) => emit('onChangeAccount', val, action);
    const status = reactive({
      timeout: 60,
      textBeforeSend: '获取验证码',
      isSending: false
    });
    const timeOut = ref();
    const formRef = ref();
    const form = reactive({
      phoneNumber: '',
      newPassword: "",
      code: "",
      rePassword: ""
    });
    const {
      newPassword,
      rePassword
    } = toRefs(form);
    const rules = reactive({
      phoneNumber: [{
        required: true,
        message: '请填写您的账号',
        trigger: 'change'
      }],
      code: [{
        required: true,
        message: '请填写您的验证码',
        trigger: 'change'
      }],
      newPassword: [{
        required: true,
        message: '请填写您的密码',
        trigger: 'change'
      }],
      rePassword: [{
        required: true,
        message: '请填写确认密码',
        trigger: 'change'
      }]
    });
    const onSubmit = async () => {
      const formEl = unref(formRef);
      await formEl.validate((valid, fields) => {
        if (newPassword === rePassword) {
          ElMessage.error('两次输入的密码不一致');
          return;
        }
        if (valid) {
          checkVerificationCode({
            mobile: form.phoneNumber,
            code: form.code
          }).then(() => {
            updateUserPassword({
              password: form.newPassword,
              userName: form.phoneNumber
            }).then(res => {
              ElMessage({
                message: "密码修改成功，请重新登录",
                type: "success"
              });
              Cookies.set('Authorization', '');
              Cookies.set('EDU-ORGANIZATION', '');
              sessionStorage.setItem('oldToken', '');
              sessionStorage.setItem('oldOrganization', '');
              location.reload();
            });
          });
        }
      });
    };
    const onSubmitAccount = async () => {
      const formEl = unref(formRef);
      await formEl.validate((valid, fields) => {
        if (newPassword === rePassword) {
          ElMessage.error('两次输入的密码不一致');
          return;
        }
        if (valid) {
          checkVerificationCode({
            mobile: form.phoneNumber,
            code: form.code
          }).then(() => {
            updateUserMobile({
              password: form.newPassword,
              userName: form.phoneNumber
            }).then(res => {
              ElMessage({
                message: "更换成功，请重新登录",
                type: "success"
              });
            });
          });
        }
      });
    };
    const nextOnSubmit = async () => {
      const formEl = unref(formRef);
      await formEl.validate((valid, fields) => {
        if (valid) {
          checkVerificationCode({
            mobile: form.phoneNumber,
            code: form.code
          }).then(() => {
            form.phoneNumber = '';
            form.newPassword = '';
            form.code = '';
            form.rePassword = '';
            formEl.resetFields();
            changeAccount(false, true);
            clearTimeout(timeOut.value);
            status.timeout = 60;
            status.isSending = false;
          });
          // form.phoneNumber =  ''
          // form.newPassword = ''
          // form.code = ''
          // form.rePassword = ''
          // formEl.resetFields()
          // changeAccount(false, true)
          // clearTimeout(timeOut.value)
          // status.timeout = 60
          // status.isSending = false
        }
      });
      // changeAccount(false, true)
    };
    const countTime = () => {
      if (status.timeout <= 0) {
        clearTimeout(timeOut.value);
        status.timeout = 60;
        status.isSending = false;
      } else {
        timeOut.value = setTimeout(countTime, 1000);
        status.timeout = status.timeout - 1;
      }
    };
    const getMsg = () => {
      if (!form.phoneNumber) {
        ElMessage.error('手机号码不能为空');
        return;
      }
      if (status.isSending) {
        return;
      }
      status.isSending = true;
      countTime();
      if (props.isAccount) {
        getVerificationCode({
          mobile: form.phoneNumber
        });
      } else {
        checkMobile({
          mobile: form.phoneNumber,
          type: props.type === 'account' ? 2 : 1
        }).then(() => {
          getVerificationCode({
            mobile: form.phoneNumber
          });
        });
      }
    };
    onMounted(() => {
      form.phoneNumber = props?.userInfo?.userName || '';
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createBlock(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: form,
        rules: rules
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          class: "pass-form-item pass-phone",
          prop: "phoneNumber"
        }, {
          default: _withCtx(() => [_hoisted_1, _createVNode(_component_el_input, {
            modelValue: form.phoneNumber,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.phoneNumber = $event),
            disabled: !_unref(props).accountAction && !!_unref(props)?.userInfo?.userName,
            placeholder: "请输入手机号码",
            maxlength: "20",
            "input-style": {
              '--el-input-border-color': '#fff',
              '--el-input-hover-border-color': '#fff'
            }
          }, null, 8, ["modelValue", "disabled"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          class: "pass-form-item",
          prop: "code"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.code,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.code = $event),
            autocomplete: "new-password",
            placeholder: "请输入短信验证码",
            maxlength: "20",
            "input-style": {
              '--el-input-border-color': '#fff',
              '--el-input-hover-border-color': '#fff'
            }
          }, null, 8, ["modelValue"]), _createElementVNode("div", {
            class: "append",
            onClick: getMsg
          }, _toDisplayString(status.isSending ? status.timeout + 's' : status.textBeforeSend), 1)]),
          _: 1
        }), !_unref(props).isAccount ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          class: "pass-form-item",
          prop: "newPassword"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.newPassword,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.newPassword = $event),
            autocomplete: "new-password",
            type: "password",
            placeholder: "设置密码（8-20字，包含字母和数字）",
            maxlength: "20",
            "input-style": {
              '--el-input-border-color': '#fff',
              '--el-input-hover-border-color': '#fff'
            }
          }, null, 8, ["modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), !_unref(props).isAccount ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 1,
          class: _normalizeClass(_unref(props).showLogin ? 'pass-form-item rePassword' : 'pass-form-item'),
          prop: "rePassword"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.rePassword,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.rePassword = $event),
            type: "password",
            placeholder: "再次输入密码",
            maxlength: "20",
            "input-style": {
              '--el-input-border-color': '#fff',
              '--el-input-hover-border-color': '#fff'
            }
          }, null, 8, ["modelValue"])]),
          _: 1
        }, 8, ["class"])) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_el_form_item, {
          class: "go-login"
        }, {
          default: _withCtx(() => [_createTextVNode(" 已有账号，"), _createElementVNode("span", {
            onClick: _cache[4] || (_cache[4] = $event => changeLoginType('login'))
          }, "登录")]),
          _: 1
        }, 512), [[_vShow, _unref(props).showLogin]]), _createVNode(_component_el_form_item, {
          class: "change-submit"
        }, {
          default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
            class: "change-btn",
            type: "primary",
            onClick: onSubmit
          }, {
            default: _withCtx(() => [_createTextVNode("确认")]),
            _: 1
          }, 512), [[_vShow, !_unref(props).accountAction && !_unref(props).isAccount]]), _withDirectives(_createVNode(_component_el_button, {
            class: "change-btn",
            type: "primary",
            onClick: nextOnSubmit
          }, {
            default: _withCtx(() => [_createTextVNode("下一步")]),
            _: 1
          }, 512), [[_vShow, _unref(props).isAccount]]), _withDirectives(_createVNode(_component_el_button, {
            class: "change-btn",
            type: "primary",
            onClick: onSubmitAccount
          }, {
            default: _withCtx(() => [_createTextVNode("确认更改")]),
            _: 1
          }, 512), [[_vShow, _unref(props).accountAction]])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules"]);
    };
  }
};